import * as React from "react"

const Introduction = ({ project }) => {
  var details = project.details.map((detail, index) => {
    return (
      <div className='detail mb40' key={index}>
        <p className='m0 text-light'>{detail.title}</p>
        <div dangerouslySetInnerHTML={{ __html: detail.details }}></div>
      </div>
    )
  })
  return (
    <div className='introduction p10'>
      <div className='max-1400 bt1 ma pt10'>
        <p className='m0 uppercase text-light with-dot'>Overview</p>
        <div className='flex mt40 m-reverse m-wrap'>
          <div className='w-30 m-100 text-normal lh-135 pr20'>
            {details}
          </div>
          <div className='w-70 m-100 m-mb40'>
            <p className='m0 h3 medium text-light mb40'>{project.introductionText}</p>
            <a className='link with-dot grey-dot  text-normal' href={project.websiteLink}>Visit the <span className='text-light underline'>Live Site</span></a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Introduction
